import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faPinterestP } from '@fortawesome/free-brands-svg-icons/faPinterestP';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { Link } from '../..';

interface Props {
  additionalId?: string,
};

const Social = ({ additionalId }: Props): JSX.Element => (
  <>
    <Link
      className='p-2 text-2xl lg:text-xs hover:text-sapphire-300'
      to='https://www.facebook.com/urbansitter/'
      title='Facebook'
      newTab
      external
    >
      <FontAwesomeIcon icon={faFacebookF} id={`${additionalId}footer-facebook`} />
    </Link>
    <Link
      className='p-2 text-2xl lg:text-xs hover:text-sapphire-300'
      to='https://www.instagram.com/urbansitter/'
      title='Instagram'
      newTab
      external
    >
      <FontAwesomeIcon icon={faInstagram} id={`${additionalId}footer-instagram`} />
    </Link>
    <Link
      className='p-2 text-2xl lg:text-xs hover:text-sapphire-300'
      to='https://twitter.com/urbansitter/'
      title='Twitter'
      newTab
      external
    >
      <FontAwesomeIcon icon={faTwitter} id={`${additionalId}footer-twitter`} />
    </Link>
    <Link
      className='p-2 text-2xl lg:text-xs hover:text-sapphire-300'
      to='https://www.pinterest.com/urbansitter/'
      title='Pinterest'
      newTab
      external
    >
      <FontAwesomeIcon icon={faPinterestP} id={`${additionalId}footer-pinterest`} />
    </Link>
    <Link
      className='p-2 text-2xl lg:text-xs hover:text-sapphire-300'
      to='https://www.youtube.com/urbansitter/'
      title='YouTube'
      newTab
      external
    >
      <FontAwesomeIcon icon={faYoutube} id={`${additionalId}footer-youtube`} />
    </Link>
  </>
);

export default Social;
